import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';

import { VpVideoPlayer, VpIcon, VpDocViewer } from '../../components';

// styles
const StyledContainer = styled(Box)({
  justifyContent: 'center',
  alignContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '6px',
  minHeight: 'calc(100% - 60px)'
});
const StyledBlurredImage = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  filter: 'blur(20px) brightness(.75) drop-shadow(0 0 20px black);'
});
const StyledIcon = styled(VpIcon)({
  position: 'relative',
  width: '100%',
  height: '100%'
});
const StyledImage = styled(Box)({
  position: 'relative',
  width: '100%',
  height: '100%',
  objectFit: 'cover'
});
const StyledSkeleton = styled(Skeleton)({
  width: '100%',
  height: '100%',
  position: 'absolute'
});

export const VpMediaInfoPreview = ({ media }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const isVideo = media?.type === 'VIDEO';
  const isImage = media?.type === 'IMAGE';
  const isDocument = !isVideo && !isImage;
  const thumbnailUrl = media?.thumbnailUrl || media?.path;

  const handleOnLoad = () => {
    setIsLoading(false);
  };
  const handleError = () => {
    setIsLoading(false);
    setHasError(true);
  };

  if (isDocument) {
    return <VpDocViewer document={media} />;
  }

  return (
    <StyledContainer>
      {!hasError && <StyledBlurredImage component="img" src={thumbnailUrl} />}
      {isVideo ? (
        <VpVideoPlayer onLoad={handleOnLoad} mediaUrl={media?.mediaUrl} />
      ) : hasError ? (
        <StyledIcon icon="Paperclip" />
      ) : (
        <StyledImage
          key={thumbnailUrl}
          component="img"
          onLoad={handleOnLoad}
          onError={handleError}
          src={thumbnailUrl}
        />
      )}
      {isLoading && <StyledSkeleton variant="rectangular" />}
    </StyledContainer>
  );
};

VpMediaInfoPreview.propTypes = {
  media: PropTypes.shape({
    mediaUrl: PropTypes.string,
    mediaId: PropTypes.string,
    thumbnailUrl: PropTypes.string,
    path: PropTypes.string,
    attachmentId: PropTypes.string,
    type: PropTypes.string
  })
};

export default VpMediaInfoPreview;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpMediaInfoPreview.jsx